<div class="dx-card wide-card">
    <h4 class="content-block ap-green">H2 Forecast: Global, Region and/or Country</h4>
    <div class="content-block">
        <h2-forecast-filters (viewReport)="getH2ForecastByRegion($event)" (showAddlData)="setAdditionalDataFlag($event)"
            [regionDataSource]='regionDataSource' [dataSource]='dataSource'
            [showAdditionalDataSwitch]=true></h2-forecast-filters>
        <hr />
        <div *ngIf="showReport" class="content-block">
            <div id="map" style="float: left;margin-right: 15px;"></div>
            <div id="forecastCategoryLegend">
            </div>
            <div id="sizeLegend">
            </div>
        </div>
    </div>
    <dx-data-grid *ngIf="showReport" id="H2ForecastByRegionGrid" class="fixGridHeight" [dataSource]="reportDataSource" [showRowLines]="true"
        [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="false" [rowAlternationEnabled]="true">
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
        </dxo-toolbar>
        <dxi-column dataField="hycoRegions" [fixed]="includeAdditionalData ? true : false" width="80" caption="Region"
            [visible]="includeAdditionalData"></dxi-column>
        <dxi-column dataField="countryName" [fixed]="includeAdditionalData ? true : false" width="100"
            caption="Country"></dxi-column>
        <dxi-column dataField="province" caption="State/Province" [fixed]="includeAdditionalData ? true : false"
            width="100"></dxi-column>
        <dxi-column dataField="city" [fixed]="includeAdditionalData ? true : false" width="100"></dxi-column>
        <dxi-column dataField="company" [fixed]="includeAdditionalData ? true : false" width="150"></dxi-column>
        <dxi-column dataField="companyType" width="150" caption="Company Type"
            [visible]="includeAdditionalData"></dxi-column>
        <dxi-column dataField="apAmenable" caption="AP Amenable?" [visible]="includeAdditionalData"
            width="90"></dxi-column>
        <dxi-column dataField="status" width="65"></dxi-column>
        <dxi-column dataField="estimatedAwardYear" width="80"></dxi-column>
        <dxi-column dataField="hydrogen" caption="Hydrogen (kNm3/h)" width="80"></dxi-column>
        <dxi-column dataField="hydrogenMMSCFD" width="90" caption="Hydrogen (MMSCFD)"></dxi-column>
        <dxi-column dataField="probability" width="90" caption="Probability %"></dxi-column>
        <dxi-column dataField="probabilityWeightedHydrogen" width="90"
            caption="Probability Weighted Hydrogen (kNm3/h)"></dxi-column>
        <dxi-column dataField="probabilityWeightedHydrogenMMSCFD" width="90"
            caption="Probability Weighted Hydrogen (MMSCFD)"></dxi-column>
        <dxi-column dataField="forecastDriver" width="180"></dxi-column>
        <dxi-column dataField="supplyType" width="130"></dxi-column>
        <dxi-column dataField="businessModel" width="100"></dxi-column>
        <dxi-column dataField="supplyMode" width="100" [visible]="includeAdditionalData"></dxi-column>
        <dxi-column dataField="notes" [visible]="includeAdditionalData" width="500"></dxi-column>
        <dxi-column dataField="productionFacilityID" caption="Facility ID" width="100"></dxi-column>
        <dxo-summary>
            <dxi-total-item displayFormat="Hydrogen Total: {0}" column="hydrogenMMSCFD" summaryType="sum" alignment="center">
            </dxi-total-item>
            <dxi-total-item column="probabilityWeightedHydrogenMMSCFD" summaryType="sum" alignment="right">
            </dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="false" [closeOnOutsideClick]="false">
</dx-load-panel>